var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row grid" },
    _vm._l(_setup.props.lengths, function (length, key) {
      return _c(
        "a",
        { key: length.sku, staticClass: "col-sm-6 col-xl-3" },
        [
          _c(_setup.MouldingResult, {
            attrs: {
              moulding: length,
              selected: _vm.value && length.sku === _vm.value.sku,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", length)
              },
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }